import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/uber/posIntegration';

const getToken = (systemSource, code, redirectUri) => {
	return Client.get(systemSourceUrl(systemSource, `${baseUrl}/token`), {
		code,
		redirectUri,
	});
};

// TODO: Optimise
const branchStatus = (systemSource, merchantId, branchId, companyCode) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-cooperation/${merchantId}/onlineCooperationCompanyRelations`
		),
		{ branchId, companyCode }
	);
	// return Client.get(`${baseUrl}/${merchantId}/${branchId}/pos_data`);
};

const stores = (systemSource, posProvisioningToken, limit, startKey) => {
	return Client.get(systemSourceUrl(systemSource, `${baseUrl}/stores`), {
		posProvisioningToken,
		startKey,
		limit,
	});
};

const bind = (
	systemSource,
	merchantId,
	branchId,
	uberStoreId,
	uberStoreName,
	posIntegrationEnabled,
	posProvisioningToken,
	operateBy
) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/pos_data`),
		{
			branchId,
			uberStoreId,
			uberStoreName,
			posIntegrationEnabled,
			posProvisioningToken,
			operateBy,
		}
	);
};

const unbind = (
	systemSource,
	merchantId,
	branchId,
	uberStoreId,
	posProvisioningToken,
	operateBy
) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/pos_data/remove`),
		{
			branchId,
			uberStoreId,
			posProvisioningToken,
			operateBy,
		}
	);
};

export default {
	getToken,
	branchStatus,
	stores,
	bind,
	unbind,
};
